var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStoryBg1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1080,
    height: 1920,
    viewBox: "0 0 1080 1920",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M299.686 -1333L540 962L-136.773 -1244.07L-579.086 -1056.02L540 962L-912.882 -830.738L-1252.74 -490.882L540 962L-1498.48 -119.378L-1678.27 326.355L540 962L-1755 721.686V1202.31L540 962L-1666.07 1638.77L-1478.02 2081.09L540 962L-1252.74 2414.88L-912.884 2754.74L540 962L-541.378 3000.48L-95.6434 3180.27L540 962L299.686 3257H780.314L540 962L1216.77 3168.07L1659.09 2980.02L540 962L1992.88 2754.74L2332.74 2414.88L540 962L2578.48 2043.38L2758.27 1597.65L540 962L2835 1202.31V721.686L540 962L2746.07 285.227L2558.02 -157.087L540 962L2332.74 -490.882L1992.88 -830.738L540 962L1621.38 -1076.48L1175.65 -1256.27L540 962L780.314 -1333H299.686Z",
    fill: "url(#paint0_radial_9019_10177)",
    fillOpacity: 0.15
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_9019_10177",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(540 962) rotate(-45) scale(3245.62)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.106556,
    stopColor: "#018FDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171778,
    stopColor: "#6B40EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.599678,
    stopColor: "#6B40EA",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoryBg1);
export default __webpack_public_path__ + "static/media/story-bg1.486f387d0f0d8b7b80a2a9a76f5833d0.svg";
export { ForwardRef as ReactComponent };